// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_2o3JI","modalControls":"_3x3y4","deleteBtnWrapper":"_3qnjx"};